import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/antd.css';
import { StoreProvider } from 'easy-peasy';
import { store } from './app/store/store'; // or 'antd/dist/antd.less'

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <StoreProvider store={store}>
//     <App />
//   </StoreProvider>
// );

ReactDOM.render(
  <StoreProvider store={store}>
    <App />
  </StoreProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
